const VideoPlayButtonIcon = () => {
  return (
    <svg viewBox="0 0 200 148" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0" maskUnits="userSpaceOnUse" x="0" y="0" width="200" height="148">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M200 0H0v148h200V0zM56 37a6 6 0 0 0-6 6v62a6 6 0 0 0 6 6h88a6 6 0 0 0 6-6V43a6 6 0 0 0-6-6H56z"
        />
      </mask>
      <g mask="url(#mask0)" fillOpacity="1">
        <rect fill="#006633" x="50" y="37" width="100" height="74" rx="6" className="pulse" />
        <rect stroke="#006633" strokeWidth="5" x="52.5" y="39.5" width="95" height="69" rx="3.5" className="shine" />
      </g>
      <path
        fill="#006633"
        fillOpacity="1"
        fillRule="evenodd"
        d="M56 37a6 6 0 0 0-6 6v62a6 6 0 0 0 6 6h88a6 6 0 0 0 6-6V43a6 6 0 0 0-6-6H56zm66 37L89 55v38l33-19z"
      />
      <path fill="#FFFFFF" d="M89 93V55l33 19-33 19z" />
    </svg>
  );
};

export default VideoPlayButtonIcon;
